<template>
  <div class="container">
    <emd-text data-testid="error-title">{{ $t(`${getError}.title`) }}</emd-text>
    <emd-text
      size="medium"
      class="eu-my_4"
      data-testid="error-description"
      >{{ $t(`${getError}.description`) }}</emd-text
    >
    <emd-button
      color="primary"
      type="outline"
      data-testid="action-button-retry"
      @click="$emit('retry')"
    >
      <span>{{ $t('retry') }}</span>
    </emd-button>
  </div>
</template>
<script>
import { EmdButton, EmdText } from 'emerald-vue/src/components'

import PropsValidator from '@/utils/validator'
import { BOLETO_CANCEL_ERRORS_ENUM } from '@/enums/boleto-cancel-errors.enum'

export default {
  name: 'ErrorStep',
  components: {
    EmdButton,
    EmdText
  },
  props: {
    error: String,
    default: () => BOLETO_CANCEL_ERRORS_ENUM.GENERIC.toLowerCase(),
    validation: error =>
      PropsValidator.validate(
        Object.keys(BOLETO_CANCEL_ERRORS_ENUM),
        error.toUpperCase()
      )
  },
  computed: {
    getError () {
      return this.error.toLowerCase()
    }
  }
}
</script>
<style>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<i18n>
{
  "pt-BR": {
    "incorrect_bank_details.title": "Dados bancários incorretos",
    "incorrect_bank_details.description": "Tente revisar os dados informados e solicitar novamente.",
    "insufficient_funds.title": "Saldo insuficiente",
    "insufficient_funds.description": "O saldo atual deve ser suficiente para o estorno solicitado. Consulte os valores a receber ou se o saldo está comprometido.",
    "generic.title": "Não foi possível concluir a ação",
    "generic.description": "Algo inesperado aconteceu. Que tal tentar outra vez?",
    "retry": "Tentar outra vez"
  },
  "en-US": {
    "incorrect_bank_details.title": "Incorrect Bank Details",
    "incorrect_bank_details.description": "Try reviewing your input and request again",
    "insufficient_funds.title": "Insufficient Funds",
    "insufficient_funds.description": "The ammount should be enough for the refund. Review the amount for the refund or check if your balance is enough.",
    "generic.title": "Could not complete action",
    "generic.description": "Try reviewing your inputs and request again.",
    "retry": "Retry"
  }
}
</i18n>
